const KEY = 'has_loaded';

function randomNumber(min, max) { 
  return Math.random() * (max - min) + min;
} 

class Loading {
  constructor() {
    if(window.location.pathname !== '/') return;
    this.isSelected = false;
    this.section = $('[data-loading-section]');
    this.container = $('[data-loading-container]');
    this.headerLogo = $('.header__logo');
    this.fullImage = $('[data-full-image]');
    this.logo = $('[data-loading-logo]');
    this.images = $('[data-loading-image]')
    this.heroImage = $('.pal-hero').find('img');
    this.pageX = window.innerWidth / 2;
    this.pageY = window.innerHeight / 2;

    if(window.location.search.includes('cart')) {
      $('.cart-notification__bubble').removeClass('loading')
      $('.sticky-menu').removeClass('loading');
      cart.openCart();
      this.headerLogo.removeClass('loading');
      return this.removeSection();
    };

    // if(localStorage.getItem(KEY)) {
    //   $('.sticky-menu').removeClass('loading');
    //   this.headerLogo.removeClass('loading');
    //   return this.removeSection();
    // }

    this.x = 50 * 0.78;
    this.y = 50 * 1.08;

    this.animate = this.animate.bind(this);
    this.animate();
    this.animateImage = this.animateImage.bind(this);

    this.initialAnimation();

    this.addEventListeners();
    this.container.css('transform-origin', `${this.x}% ${this.y}%`)

    setTimeout(() => {
      const randomIndex = Math.floor(Math.random() * (this.images.length - 1) + 1);
      const item = this.images[randomIndex];
      const url = item.querySelector('img').src;
      const pos = item.getBoundingClientRect();
      this.isPaused = true;
      item.style.display = 'none'
      
      if(!this.isSelected) {
        item.classList.add('selected');
        this.animateImage(url, pos);
      }
      
      this.isSelected = true;

    }, 15000)
  }


  addEventListeners() {
    window.addEventListener('mousemove', (e) => {
      this.pageX = e.pageX;
      this.pageY = e.pageY;
      // this.x = xPercent * 0.7;
      // this.y = yPercent * 1.08;
    })

    window.addEventListener('touchmove', (e) => {
      let touch = e.touches[0];
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
      const currentElement = document.elementFromPoint(touch.pageX, touch.pageY);
      if(currentElement.nodeName == 'IMG') {
        currentElement.parentElement.classList.add('hovered')
      } else {
        this.images.removeClass('hovered')
      }
      // this.x = xPercent * 0.7;
      // this.y = yPercent * 1.08;
    })

    this.images.on('click', (e) => {
      const el = $(e.originalEvent.target);
      const url = el.attr('src');
      const pos = el[0].getBoundingClientRect();
      this.isPaused = true;
      el.parent().css('display', 'none')
      
      if(!this.isSelected) {
        el.closest('.loading-section__image').addClass('selected');
        this.animateImage(url, pos);
      }
      
      this.isSelected = true;
    })
  }

  initialAnimation() {
    this.images.css('transition', 'transform 800ms ease-in-out')
    this.images.find('img').css('transition', 'opacity 800ms ease-in-out')
    gsap.to(this.images, {
      opacity: 1,
      delay: 1,
      duration: 0.8,
      ease: 'Power1.inOut',
      onComplete: () => {
        this.images.removeClass('initial')
        scrollEvents && scrollEvents.initialize();
        scrollingImages && scrollingImages.initialize();
        setTimeout(() => {
          this.isPaused = false;
          this.images.css('transition', 'transform 500ms ease-in-out')
          this.images.find('img').css('transition', 'opacity 500ms ease-in-out')
        }, 800)
      }
    })
  }

  animate() {
    const xPercent = this.pageX / window.innerWidth * 100;
    const yPercent = this.pageY / window.innerHeight * 100;

    const speed = window.innerWidth <= 768 ? 0.06 : 0.03;
    
    this.y = lerp(this.y, yPercent * 1.08, speed);
    this.x = lerp(this.x, xPercent * 0.78, speed);
     

    this.container.css('transform-origin', `${this.x}% ${this.y}%`)
    requestAnimationFrame(this.animate);
  }

  animateLogo() {
    const headerLogoPos = this.headerLogo[0].getBoundingClientRect();
    const logoPos = this.logo[0].getBoundingClientRect();
    const percent = headerLogoPos.width / logoPos.width;

    gsap.to(this.logo, {
      scale: percent,
      zIndex: 10,
      y: -(logoPos.y - headerLogoPos.y + (headerLogoPos.height / 1.7)),
      duration: 1.2,
      ease: 'expo.inOut'
    })

    setTimeout(() => {
      $('.sticky-menu').removeClass('loading')
    }, 200)

    gsap.to(this.logo.find('svg'), {
      fill: 'white',
      duration: 1.2,
      ease: 'expo.inOut',
      onComplete: () => {
        this.headerLogo.removeClass('loading')
        $('.cart-notification__bubble').removeClass('loading')
        $('body').removeClass('loading')
        this.removeSection()
        localStorage.setItem(KEY, true)
      }
    })
  }

animateImage(url, pos) {
  this.animateLogo();
  this.heroImage.attr('srcset', url);
  this.heroImage.attr('src', url);
  this.fullImage.find('img').attr('src', url);

  // Ensure object-position is correct for images 12 and 18
  this.fullImage.find("img").each((index, img) => {
    if (img.src.includes("img-12.jpg")) {
      $(img).css("object-position", "top");
    }
    if (img.src.includes("img-18.jpg")) {
      $(img).css("object-position", "center 80%");
    }
  });

  localStorage.setItem('homeImage', url);
  this.fullImage.removeClass('hidden');
  this.fullImage.css({
    'width': pos.width,
    'height': pos.height,
    'top': pos.y,
    'left': pos.x
  });

  gsap.to(this.images, {
    opacity: 0,
    duration: 1.2,
    ease: 'expo.inOut'
  });

  gsap.to(this.fullImage[0], {
    width: window.innerWidth - 24,
    height: window.innerHeight - 24,
    top: 12,
    left: 12,
    duration: 1.2,
    ease: 'expo.inOut'
  });
}


  removeSection() {
    gsap.to(this.section, {
      opacity: 0,
      duration: 0.4,
      onComplete: () => {
        this.section.remove();
      }
    })
  }
}

const loading = new Loading();
